import {
  GroupLabelCreateRequestPayload,
  GroupLabelUpdateRequestPayload,
  SearchGroupLabelPayload,
  SearchGroupLabelResponse,
} from "@/domain/grouplabel.interface";
import { GroupLabel } from "@/domain/organizations.interface";
import { axios, transformAxiosError } from "@/utils/axios.create";

const findAll = async (): Promise<GroupLabel[]> => {
  return axios
    .get("/organizations/group-labels")
    .then((res) => {
      return (res.data.body as GroupLabel[]) || [];
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const search = async ({
  search,
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
}: SearchGroupLabelPayload): Promise<SearchGroupLabelResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    search,
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/organizations/group-labels/search?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        groupLabels: body.groupLabels,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (data: GroupLabelCreateRequestPayload) => {
  return axios
    .post("/organizations/group-labels", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: GroupLabelUpdateRequestPayload;
}) => {
  return axios
    .put(`/organizations/group-labels/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/organizations/group-labels/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const GroupLabelsService = {
  findAll,
  search,
  create,
  update,
  softDelete,
};
